import React from "react";
import { Phone, RefreshCw } from "lucide-react";

const FALLBACK_PHONE = "(208) 467-4479";

export default function SiteError({ onRetry }) {
  return (
    <div className="min-h-screen bg-[#0c1729] text-white flex items-center justify-center px-6 text-center" data-testid="site-error">
      <div className="max-w-md">
        <img src="/assets/hbhs-logo-clean-gold.png" alt="Hilty, Bower, Haws & Seable, PLLC" className="w-64 mx-auto mb-10" />
        <h1 className="font-serif text-3xl md:text-4xl">We&rsquo;re having trouble loading the site</h1>
        <p className="text-stone-300 mt-4 leading-relaxed">Please try again in a moment, or call our office directly.</p>
        <a href={`tel:${FALLBACK_PHONE.replace(/\D/g, "")}`} className="mt-8 inline-flex items-center gap-2 font-serif text-2xl text-[#d4b87a] hover:text-white" data-testid="site-error-phone">
          <Phone className="w-5 h-5" /> {FALLBACK_PHONE}
        </a>
        <div className="mt-8">
          <button onClick={onRetry || (() => window.location.reload())} className="inline-flex items-center gap-2 h-11 px-6 border border-white/40 uppercase tracking-[0.2em] text-[11px] hover:bg-white hover:text-[#0c1729] transition-colors" data-testid="site-error-retry">
            <RefreshCw className="w-4 h-4" /> Try Again
          </button>
        </div>
      </div>
    </div>
  );
}

export class ErrorBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    return this.state.hasError ? <SiteError /> : this.props.children;
  }
}
